/**
 * Translations for Universe App
 * Ticket #79: Set preferred language via Profile setting
 */

const translations = {
  de: {
    // Common
    back: 'Zurück',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    send: 'Senden',
    loading: 'Laden...',
    loadingPosts: 'Lädt Posts...',
    loadingMorePosts: 'Weitere Inhalte werden geladen...',
    allPostsLoaded: 'Alle Inhalte geladen',
    error: 'Fehler',
    success: 'Erfolg',
    yes: 'Ja',
    no: 'Nein',
    close: 'Schließen',
    search: 'Suchen',
    filter: 'Filter',
    all: 'Alle',
    none: 'Keine',
    more: 'Mehr',
    less: 'Weniger',
    readMore: 'mehr lesen',
    readLess: 'weniger lesen',
    backToLogin: 'Zurück zum Login',
    reported: 'GEMELDET',
    noResults: 'Keine Ergebnisse gefunden',

    // Navigation
    nav: {
      home: 'Home',
      profile: 'Profil',
      marketplace: 'Marktplatz',
      courses: 'Kurse',
      chat: 'Chat',
      settings: 'Einstellungen',
      logout: 'Abmelden',
      loggingOut: 'Abmelden...',
    },

    // Bottom Navigation
    bottomNav: {
      home: 'Home',
      messages: 'Nachrichten',
      post: 'Posten',
      notifications: 'Mitteilungen',
      profile: 'Profil',
    },

    // Hamburger Menu
    menu: {
      meinePosts: 'Meine Posts',
      meinMarktplatz: 'Mein Marktplatz',
      meineKursbewertungen: 'Meine Kursbewertungen',
      changePassword: 'Passwort ändern',
      language: 'Sprache',
      logout: 'Abmelden',
    },

    // Tabs
    tabs: {
      hotPosts: 'Hot Posts',
      newPosts: 'Neue Posts',
      marketplace: 'Marktplatz',
      iOffer: 'ich biete',
      iSearch: 'ich suche',
      favorites: 'Favoriten',
      myObjects: 'Meine Objekte',
    },

    // Auth
    auth: {
      login: 'Anmelden',
      loggingIn: 'Wird eingeloggt...',
      register: 'Registrieren',
      registering: 'Wird erstellt...',
      email: 'E-Mail',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',
      repeatPassword: 'Passwort wiederholen',
      forgotPassword: 'Passwort vergessen',
      createAccount: 'Konto erstellen',
      alreadyHaveAccount: 'Hast du bereits ein Konto?',
      loginHere: 'Hier einloggen',
      noAccount: 'Noch kein Konto?',
      studentEmail: 'Student E-Mail',
      studentEmailLabel: 'Studenten-E-Mail-Adresse',
      firstName: 'Vorname',
      lastName: 'Nachname',
      welcomeBack: 'Willkommen zurück!',
      loginForm: 'Anmeldeformular',
      registerForm: 'Registrierungsformular',
      emailRequired: 'E-Mail ist erforderlich',
      passwordRequired: 'Passwort ist erforderlich',
      firstNameRequired: 'Vorname ist erforderlich',
      lastNameRequired: 'Nachname ist erforderlich',
      invalidEmail: 'Keine gültige E-Mail Adresse. Bitte verwende deine Studenten-E-Mail Adresse von deiner Hochschule. Möglicherweise ist deine Hochschule noch nicht in Universe.',
      weakPassword: 'Passwort muss mindestens 8 Zeichen enthalten und eine Kombination von Buchstaben, Nummern und Sonderzeichen sein.',
      repeatPasswordRequired: 'Bitte wiederhole dein Passwort',
      passwordMismatch: 'Passwörter stimmen nicht überein',
      verificationHelp: 'Dein Benutzerkonto wird aktiviert, nachdem du deine E-Mail verifiziert hast.',
      // Issue #68: Privacy policy notice on registration
      privacyPolicyNotice: 'Mit der Erstellung eines Kontos akzeptierst du unsere',
      verificationEmailSent: 'Ein Link zur Verifizierung deiner E-Mail wurde verschickt. Bitte verifiziere deine E-Mail innerhalb von 24 Stunden.',
      // Issue #380: Immediate verification-email failure screen
      verificationEmailImmediateErrorPrefix: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut. Soll dieser Fehler weiter auftreten, wende dich an ',
      verificationEmailImmediateErrorSuffix: '.',
      resendLinkButton: 'Link erneut senden',
      allesKlar: 'Alles klar',
      university: 'Hochschule',
      emailNotReceived: 'E-Mail nicht erhalten?',
      resendVerification: 'Verifizierungsemail erneut senden',
      noLinkReceived: 'Haben Sie keinen Link erhalten?',
      verificationResent: 'Verifizierungslink wurde erneut gesendet',
      emailLabel: 'Ihre E-Mail-Adresse',
      resendHelpText: 'Geben Sie die E-Mail-Adresse ein, für die Sie eine neue Verifizierungs-E-Mail erhalten möchten.',
      sending: 'Wird gesendet...',
      resendVerificationButton: 'Verifizierungsemail erneut senden',
      verificationLinkSentSuccess: 'Der Verifizierungslink ist erfolgreich gesendet.',
      customerServiceNotice: 'Wenn du trotz des erneuten Versuchs keine E-Mail erhalten hast, wende dich bitte an unseren Kundenservice unter ',
      customerServiceEmail: 'kundenservice@universe-app.online',
      registerHere: 'Hier registrieren',
      hidePasswordRepeat: 'Passwort-Wiederholung verbergen',
      showPasswordRepeat: 'Passwort-Wiederholung anzeigen',
      systemUnavailable: 'Das System ist vorübergehend nicht verfügbar. Bitte versuche es später erneut.',
      // Issue #235: AGB checkbox translations
      agbCheckboxPrefix: 'Ich habe die',
      agbLinkText: 'AGB',
      agbCheckboxSuffix: 'gelesen und akzeptiere sie.',
      agbRequired: 'Um ein Konto bei uns zu erstellen, ist es erforderlich, unsere AGB zu akzeptieren.',
    },

    // Forgot Password
    forgotPassword: {
      title: 'Passwort vergessen',
      sentTitle: 'Passwort geschickt',
      instructions: 'Gib deine Student E-Mail Adresse ein, um ein Einmalpasswort zu erhalten.',
      sendOtp: 'Einmalpasswort senden',
      sending: 'Wird gesendet...',
      backToLogin: 'Zurück zum Login',
      checkEmail: 'Bitte überprüfe dein E-Mail-Postfach.',
      otpValid: 'Das einmalige Passwort ist 24 Stunden gültig.',
      understood: 'Alles klar',
      emailNotFound: 'Diese E-Mail Adresse konnte nicht gefunden werden.',
      defaultSuccess: 'Ein einmaliges Passwort wurde an deine E-Mail-Adresse gesendet.',
    },

    // Profile
    profile: {
      title: 'Profil',
      accountInfo: 'Kontoinformationen',
      account: 'Konto',
      changePassword: 'Passwort ändern',
      appSettings: 'App-Einstellungen',
      notifications: 'Benachrichtigungseinstellungen',
      language: 'Sprache',
      display: 'Anzeigeeinstellungen',
      privacy: 'Datenschutz & Richtlinien',
      terms: 'Allgemeine Geschäftsbedingungen',
      privacyPolicy: 'Datenschutzerklärung',
      communityGuidelines: 'Community-Richtlinien',
      uploadPhoto: 'Foto hochladen',
      changePhoto: 'Foto ändern',
      // Issue #84: Profile photo translations
      photoAlt: 'Profilfoto',
      invalidFileType: 'Ungültiges Dateiformat. Erlaubt: JPEG, PNG, WebP',
      fileTooLarge: 'Datei ist zu groß (max 5MB)',
      uploadError: 'Fehler beim Hochladen des Profilfotos',
      // Issue #137: Account settings
      accountSettings: 'Kontoeinstellungen',
    },

    // Language Settings
    languageSettings: {
      title: 'Sprache',
      setPreferred: 'Bevorzugte Sprache einstellen',
      german: 'Deutsch',
      english: 'Englisch',
      saving: 'Speichern...',
      saveError: 'Fehler beim Speichern der Spracheinstellung',
    },

    // Issue #137: Account Settings
    accountSettings: {
      title: 'Kontoeinstellungen',
      profileInfo: 'Profilinformationen',
      name: 'Name',
      email: 'E-Mail',
      university: 'Universität',
      accountStatus: 'Kontostatus',
      accountStatusActive: 'Aktiv seit',
      accountManagement: 'Kontoverwaltung',
      deleteAccount: 'Konto löschen',
    },

    // Issue #137: Delete Account
    deleteAccount: {
      title: 'Konto löschen',
      step: 'Schritt {current} von {total}',
      step1Title: 'schade, dass du uns verlässt.',
      step1Text: 'Möchtest du dein Konto wirklich löschen? Du kannst dann nicht mehr auf deine Kontakte, Nachrichten und vor allem die Inhalte von UNIVERSE zugreifen.',
      step2Title: 'Warum möchtest du dein Konto löschen?',
      step2Text: 'Bitte teile uns mit, warum du UNIVERSE verlassen möchtest. (mindestens 1 Option auswählen)',
      reason1: 'Die Inhalte von UNIVERSE interessieren mich nicht',
      reason2: 'Ich habe mein Studium beendet und brauche die App nicht mehr',
      reason3: 'Ich bin mit der Community unzufrieden',
      reason4: 'Ich erhalte unerwünschte Kontaktanfragen',
      reason5: 'Sonstiges',
      step3Title: 'Bitte gib dein Passwort ein, um dein Konto unwiderruflich zu löschen.',
      personalDataQuestion: 'Was passiert mit deinen persönlichen Daten?',
      personalDataAnswer: 'Deine persönlichen Daten werden komplett gelöscht.',
      contentQuestion: 'Was passiert mit deinen Inhalten?',
      contentAnswer: 'Alle Marktplatzobjekte, die du erstellt hast, werden gelöscht. Die Beiträge, Kommentare, Kursbewertungen und Nachrichten, die du erstellt hast, werden nicht gelöscht, aber anonymisiert, um den Personenbezug zu entfernen. Wenn du nicht möchtest, dass von dir erstellte Inhalte bestehen bleiben, hast du die Möglichkeit, vor der Löschung deines Kontos die Inhalte zu löschen.',
      passwordPlaceholder: 'Passwort',
      passwordRequired: 'Bitte gib dein Passwort ein.',
      wrongPassword: 'Falsches Passwort.', // Issue #150
      validating: 'Überprüfen...', // Issue #150
      continue: 'Weiter',
      deleteButton: 'Konto löschen',
      confirmTitle: 'Konto löschen',
      confirmText: 'Bist du sicher, dass du dein Konto löschen möchtest? Du hast 30 Tage Zeit, um dich erneut anzumelden und die Löschung abzubrechen.',
      confirmDelete: 'Ja, löschen',
      deleting: 'Löschen...',
      errorGeneric: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
    },

    // Display Settings (Issue #98: Dark Mode)
    displaySettings: {
      title: 'Anzeigeeinstellung',
      setPreferred: 'Anzeigemodus einstellen',
      lightMode: 'Light Mode',
      darkMode: 'Dark Mode',
    },

    // Notification Settings (Issue #88)
    notificationSettings: {
      title: 'Benachrichtigungseinstellungen',
      allNotifications: 'Benachrichtigungen',
      newComment: 'Neuer Kommentar',
      newLike: 'Neuer Like',
      newHeart: 'Neues Herz',
      newChat: 'Neuer Chat',
      newStatus: 'Neues Update von gemerkten Objekten',
      statusDescription: '',
      saving: 'Speichern...',
      saveError: 'Fehler beim Speichern der Einstellung',
    },

    // Change Password
    changePassword: {
      title: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      confirmNewPassword: 'Neues Passwort wiederholen',
      submit: 'Weiter',
      submitting: 'Wird geändert...',
      newPasswordTitle: 'Neues Passwort eingeben',
      otpFlowTitle: 'Neues Passwort festlegen',
      otpFlowSubtitle: 'Bitte lege ein neues Passwort für dein Konto fest.',
      successMessage: 'Neues Passwort wurde erfolgreich festgelegt!',
      errors: {
        currentRequired: 'Aktuelles Passwort ist erforderlich',
        newRequired: 'Neues Passwort ist erforderlich',
        confirmRequired: 'Bitte wiederhole dein neues Passwort',
        mismatch: 'Passwörter stimmen nicht überein',
        weak: 'Passwort muss mindestens 8 Zeichen enthalten und eine Kombination von Alphabeten, Nummern und Symbolen sein.',
        sessionExpired: 'Sitzung abgelaufen. Bitte erneut anmelden.',
        serverError: 'Das System ist vorübergehend nicht verfügbar. Bitte versuche es später erneut.',
      },
    },

    // Marketplace
    marketplace: {
      title: 'Marktplatz',
      createObject: 'Neues Objekt erstellen',
      createObjectTitle: 'Neues Objekt für den Marktplatz erstellen',
      price: 'Preis',
      priceLabel: 'Preis *',
      titleLabel: 'Titel *',
      descriptionLabel: 'Beschreibung *',
      description: 'Beschreibung',
      uploadImagesRequired: 'Bilder hochladen (erforderlich) *',
      uploadImagesOptional: 'Bilder hochladen (optional)',
      addMoreImages: 'Mehr Bilder hinzufügen',
      maxImagesInfo: 'Maximal {count} Bilder, je max. {size}MB',
      maxImagesError: 'Maximal {count} Bilder pro Post erlaubt',
      invalidFileType: 'Ungültiger Dateityp: {name}. Nur JPEG, PNG und WebP sind erlaubt.',
      imageTooLarge: 'Bild ist zu groß',
      errorCompressing: 'Fehler beim Komprimieren',
      errorLoading: 'Fehler beim Laden',
      errorReading: 'Fehler beim Lesen',
      pleaseEnterTitle: 'Bitte gib einen Titel ein',
      pleaseEnterDescription: 'Bitte gib eine Beschreibung ein',
      pleaseEnterValidPrice: 'Bitte gib einen gültigen Preis ein',
      pleaseUploadImage: 'Bitte lade mindestens ein Bild hoch',
      errorCreating: 'Fehler beim Erstellen',
      objectCreatedSuccess: 'Objekt erfolgreich erstellt!',
      placeholderTitleOffer: 'z.B. Verkaufe Fahrrad',
      placeholderTitleSearch: 'z.B. Suche Mathematik-Lehrbuch',
      placeholderDescriptionOffer: 'Beschreibe dein Objekt...',
      placeholderDescriptionSearch: 'Beschreibe wonach du suchst...',
      creating: 'Erstelle...',
      create: 'Erstellen',
      freeGiveaway: 'Zu verschenken',
      sold: 'VERKAUFT',
      markAsSold: 'Als verkauft markieren',
      markAsSoldConfirm: 'Möchtest du dieses Objekt wirklich als verkauft markieren? Diese Aktion kann nicht rückgängig gemacht werden.',
      markAsSoldConfirmShort: 'Möchtest du dieses Objekt wirklich als verkauft markieren?',
      markAsSoldSuccess: 'Objekt wurde erfolgreich als verkauft markiert',
      // Issue #329: "Ich habe es gefunden" for search objects
      found: 'GEFUNDEN',
      markAsFound: 'Ich habe es gefunden',
      markAsFoundConfirm: 'Möchtest du dieses Objekt wirklich als gefunden markieren? Diese Aktion kann nicht rückgängig gemacht werden.',
      markAsFoundConfirmShort: 'Möchtest du dieses Objekt wirklich als gefunden markieren?',
      markAsFoundSuccess: 'Objekt wurde erfolgreich als gefunden markiert',
      objectNoLongerAvailable: 'Dieses Objekt ist leider nicht mehr verfügbar',
      marking: 'Markiere...',
      markAsAvailable: 'Als verfügbar markieren',
      contactSeller: 'Nachricht senden',
      editObject: 'Objekt bearbeiten',
      deleteObject: 'Objekt löschen',
      deleteObjectConfirm: 'Möchtest du dieses Objekt wirklich löschen?',
      report: 'Melden',
      reportObject: 'Objekt melden',
      noObjects: 'Keine Objekte gefunden',
      objectNotFound: 'Objekt nicht gefunden',
      noFavorites: 'Du hast noch keine Objekte als Favorit markiert.',
      noOwnObjects: 'Du hast noch keine Objekte erstellt.',
      loadingObjects: 'Lädt Objekte...',
      errorLoadingObjects: 'Fehler beim Laden der Objekte',
      objectTitle: 'Titel',
      objectDescription: 'Beschreibung',
      objectImages: 'Bilder',
      existingImages: 'Vorhandene Bilder:',
      newImages: 'Neue Bilder:',
      addImages: 'Bilder hinzufügen',
      compressing: 'Komprimiere...',
      searchPlaceholder: 'Suchen...',
      searchAriaLabel: 'Marktplatz durchsuchen',
      searchButtonAriaLabel: 'Suche starten',
      confirmDelete: 'Möchtest du dieses Objekt wirklich löschen?',
      hearts: 'Herzen',
      clicks: 'Klicks',
      options: 'Optionen',
      enterTitle: 'Bitte gib einen Titel ein',
      enterPrice: 'Bitte gib einen Preis ein',
      enterDescription: 'Bitte gib eine Beschreibung ein',
      saveError: 'Fehler beim Speichern',
      markSoldError: 'Fehler beim Markieren als verkauft',
      previousImage: 'Vorheriges Bild',
      nextImage: 'Nächstes Bild',
      removeHeart: 'Herz entfernen',
      addHeart: 'Herz hinzufügen',
      // Issue #385: Disabled heart for sold marketplace objects
      heartDisabledSold: 'Like nicht möglich – Objekt ist verkauft',
      edited: 'bearbeitet',
      photo: 'Foto',
      // Issue #225: Clickable preview images
      openImageGallery: 'Bild in Galerie öffnen',
      previewImage: 'Vorschaubild',
    },

    // Posts
    posts: {
      createPost: 'Neuen Beitrag erstellen',
      editPost: 'Post bearbeiten',
      deletePost: 'Post löschen',
      writePost: 'Was möchtest du teilen?',
      noPosts: 'Keine Posts gefunden',
      noOwnPosts: 'Du hast noch keine Beiträge erstellt.',
      myPosts: 'Meine Posts',
      likes: 'Gefällt mir',
      comments: 'Kommentare',
      share: 'Teilen',
      report: 'Melden',
      reportPost: 'Post melden',
      confirmDelete: 'Möchtest du diesen Post wirklich löschen?',
      deleting: 'Löschen...',
      saving: 'Speichern...',
      reporting: 'Melden...',
      // Issue #288: Search translations
      searchPlaceholder: 'Beitrag suchen...',
      searchAriaLabel: 'Beiträge durchsuchen',
      searchButtonAriaLabel: 'Suche starten',
      // Issue #317: Shared post indicator
      sharedPost: 'Geteilter Beitrag',
      // Issue #335: Link accessibility
      externalLink: 'Externer Link (öffnet in neuem Tab)',
      opensInNewTab: 'öffnet in neuem Tab',
    },

    // Comments
    comments: {
      title: 'Kommentare',
      showComments: 'Kommentare anzeigen',
      loadingComments: 'Lade Kommentare...',
      noComments: 'Noch keine Kommentare',
      writeComment: 'Schreibe einen Kommentar...',
      anonymous: 'Anonym',
      author: 'Autor', // Issue #141: Label for anonymous comments from post author
      editComment: 'Kommentar bearbeiten',
      deleteComment: 'Kommentar löschen',
      reportComment: 'Kommentar melden',
      confirmDeleteComment: 'Möchtest du diesen Kommentar wirklich löschen?',
      deleteSuccess: 'Kommentar erfolgreich gelöscht',
      reportSuccess: 'Kommentar erfolgreich gemeldet',
      reportedComment: 'Gemeldeter Kommentar', // Issue #413
      emptyError: 'Kommentar darf nicht leer sein',
      enterComment: 'Bitte gib einen Kommentar ein',
      sending: 'Sende...', // Issue #177: Shared CommentInput component
    },

    // Favorites
    favorites: {
      onlyFavorites: 'Nur Favoriten',
      filterActive: 'Filter aktiv',
    },

    // Course Reviews
    courseReview: {
      title: 'Kursbewertungen',
      detailTitle: 'Kursdetails',
      createReview: 'Review erstellen',
      editReview: 'Review bearbeiten',
      deleteReview: 'Review löschen',
      noReviews: 'Keine Bewertungen gefunden',
      noCourses: 'Keine Kurse gefunden',
      courseCountSingular: 'Kurs',
      courseCountPlural: 'Kurse',
      rating: 'Bewertung',
      review: 'Rezension',
      reviews: 'Bewertungen',
      anonymous: 'Anonym',
      rateWithStars: 'Bewerte diesen Kurs mit 1-5 Sternen',
      sharePlaceholder: 'Teile deine Erfahrung oder Tipps (optional)',
      creating: 'Wird erstellt...',
      create: 'Erstellen',
      saving: 'Wird gespeichert...',
      confirmDelete: 'Möchtest du diesen Review wirklich löschen?',
      deleting: 'Löschen...',
      loadingCourses: 'Kurse werden geladen...',
      loadingMore: 'Weitere Kurse werden geladen...',
      allLoaded: 'Alle Kurse geladen',
      errorLoading: 'Fehler beim Laden der Kurse',
      seeAllReviews: 'Alle Bewertungen ansehen',
      disclaimer: 'Bitte beachte, dass die Kursangaben ohne Gewähr sind und dass du verbindliche Informationen in dem Studienplan deiner Hochschule findest.',
      searchPlaceholder: 'Kurs suchen...',
      searchAriaLabel: 'Kurse durchsuchen',
      searchButtonAriaLabel: 'Suche starten',
      sort: {
        title: 'Sortieren',
        sortBy: 'Sortieren nach',
        reviewsDescending: 'Anzahl Reviews',
        ratingAscending: 'Reviews aufsteigend',
        ratingDescending: 'Reviews absteigend',
        nameAsc: 'A-Z',
        nameDesc: 'Z-A',
        appliedSorts: 'Angewandte Sortierkriterien',
        clear: 'Zurücksetzen',
        clearAriaLabel: 'Sortierkriterien zurücksetzen',
      },
      filter: {
        title: 'Filteroptionen',
        degree: 'Studium',
        studyProgram: 'Studiengang',
        searchProgram: 'Suchen nach Studiengang',
        language: 'Sprache',
        semester: 'Semester',
        bachelor: 'Bachelor',
        master: 'Master',
        german: 'Deutsch',
        english: 'Englisch',
        both: 'Beides',
        winterSemester: 'Wintersemester',
        summerSemester: 'Sommersemester',
        apply: 'Anwenden',
        reset: 'Filter zurücksetzen',
        // Issue #78: Rating-related filters
        ratingSection: 'Bewertung',
        hasReviews: 'Kurse mit Bewertung',
        myReviews: 'Kurse mit meiner Bewertung',
        minStars: 'Kurse mit mindestens [x] Sterne',
        minStarsAria: 'Mindestens {count} Sterne',
        minStarsRequired: 'Bitte wähle eine Sternebewertung aus.',
      },
    },

    // Chat
    chat: {
      title: 'Chat',
      noMessages: 'Keine Nachrichten',
      typeMessage: 'Nachricht eingeben...',
      send: 'Senden',
      loadingConversation: 'Lade Konversation...',
      errorLoadingConversation: 'Fehler beim Laden der Konversation',
      errorSendingMessage: 'Fehler beim Senden der Nachricht',
      privacyNotice: 'Wir schützen deine Privatsphäre. Deine Nachrichten werden verschlüsselt und lediglich dem Empfänger angezeigt.',
      // Issue #123: Unread messages marker
      unreadMessage: 'ungelesene Nachricht',
      unreadMessages: 'ungelesene Nachrichten',
      // Issue #127: Date divider accessibility
      messagesFrom: 'Nachrichten vom',
    },

    // Chat List (Issue #91, #92, #93, #121, #122, #173)
    chatList: {
      title: 'Nachrichten',
      loading: 'Lade Nachrichten...',
      errorLoading: 'Fehler beim Laden der Nachrichten',
      noConversations: 'Keine Nachrichten',
      noConversationsHint: 'Kontaktiere einen Verkäufer im Marktplatz, um eine Unterhaltung zu starten.',
      // Issue #121: Hide chat feature
      deleteChat: 'Chat löschen',
      blockUser: '{name} blockieren',
      deleteChatTitle: 'Chat löschen?',
      deleteChatMessage: 'Der Chat wird aus deiner Liste entfernt. Wenn {name} dir erneut schreibt, erscheint der Chat wieder.',
      deleteChatConfirm: 'Löschen',
      deleteChatConfirming: 'Löschen...',
      // Issue #122: Block user feature
      blockUserTitle: 'Möchtest du {name} wirklich blockieren?',
      blockUserMessage: '{name} wird dich nicht mehr kontaktieren können. Du wirst keine Nachrichten mehr von {name} erhalten.',
      blockUserConfirm: '{name} blockieren',
      blockUserConfirming: 'Blockieren...',
      blockUserCancel: 'Abbrechen',
      blockUserSuccess: 'Du hast {name} blockiert',
      // Issue #122: Accessibility translations (WCAG 2.1)
      optionsHint: 'Shift+Enter für Optionen',
      optionsMenu: 'Chat-Optionen',
      conversationWith: 'Unterhaltung mit',
      unread: 'Ungelesen',
      // Issue #173: Mute notification feature
      muteNotification: 'Notifikation ausschalten',
      unmuteNotification: 'Notifikation einschalten',
      mutingNotification: 'Wird geändert...',
      muteError: 'Fehler beim Ändern der Benachrichtigungseinstellung',
      muted: 'Stumm',
      mutedNotification: 'Benachrichtigungen stumm',
    },

    // Notifications (Issue #87)
    notifications: {
      title: 'Mitteilungen',
      loading: 'Lade Benachrichtigungen...',
      errorLoading: 'Fehler beim Laden der Benachrichtigungen',
      noNotifications: 'Keine Benachrichtigungen',
      noNotificationsHint: 'Hier erscheinen Benachrichtigungen zu Kommentaren, Likes und mehr.',
      markAllRead: 'Alle als gelesen markieren',
      justNow: 'Gerade eben',
      minutesAgo: 'Min.',
      hoursAgo: 'Std.',
      daysAgo: 'Tage',
      // Notification message templates
      commentMessage: '{actor} hat einen Kommentar zu deinem Beitrag "{title}" hinterlassen.',
      commentMessageAnonymous: 'Anonym hat einen Kommentar zu deinem Beitrag "{title}" hinterlassen.',
      likeMessage: 'Jemand hat deinen Beitrag "{title}" geliked.',
      heartMessage: 'Jemand interessiert sich für dein Marktplatz-Objekt "{title}".',
      chatMessage: '{actor} hat dir eine Nachricht gesendet.',
      favoriteSoldMessage: 'Das Marktplatz-Objekt "{title}" wurde verkauft.',
      // Issue #131: Delete notifications
      selectAll: 'Alles markieren',
      deleteSelected: 'Ausgewählte löschen',
      selected: 'ausgewählt',
      selectionMode: 'Auswahlmodus',
      exitSelectionMode: 'Auswahlmodus beenden',
      longPressToSelect: 'Lange drücken zum Auswählen',
      notificationSelected: 'Benachrichtigung ausgewählt',
      notificationDeselected: 'Benachrichtigung abgewählt',
      deleteSuccess: 'Benachrichtigung(en) gelöscht',
      deleteError: 'Fehler beim Löschen der Benachrichtigungen',
      unread: 'Ungelesen',
    },

    // Seller Contact
    sellerContact: {
      title: 'Nachricht senden',
      message: 'Nachricht',
      messagePlaceholder: 'Schreibe deine Nachricht an den Verkäufer...',
      send: 'Nachricht senden',
      sending: 'Senden...',
      enterMessage: 'Bitte gib eine Nachricht ein',
      sendError: 'Fehler beim Senden der Nachricht',
      objectNotFound: 'Objekt nicht gefunden',
      seller: 'Verkäufer',
      gdprNotice: 'Dem Empfänger deiner Nachricht wird dein Vorname und Profil angezeigt.',
    },

    // Create Options Menu
    createOptions: {
      newPost: 'Neuen Beitrag erstellen',
      newMarketplace: 'Neues Objekt für den Marktplatz erstellen',
    },

    // Create Post Page (Issue #101)
    createPost: {
      pageTitle: 'Neuen Beitrag erstellen',
      yourThoughts: 'Deine Gedanken...',
      placeholder: 'Was möchtest du teilen?',
      anonymous: 'Anonym',
      emoji: 'Emoji',
      addPhotos: 'Bilder hinzufügen (optional)',
      create: 'Erstellen',
      creating: 'Erstelle...',
    },

    // Issue #105: Unsaved changes warning
    unsavedChanges: {
      title: 'Seite verlassen?',
      message: 'Deine Eingaben werden nicht gespeichert.',
      leave: 'Verlassen',
      stay: 'Bleiben',
    },
    // Report
    report: {
      title: 'Melden',
      reason: 'Grund',
      additionalInfo: 'Zusätzliche Informationen',
      submit: 'Melden',
      submitting: 'Melden...',
      selectCategory: 'Bitte wähle eine Kategorie für die Meldung:',
      chooseCategory: '-- Kategorie wählen --',
      whyReport: 'Warum möchtest du diesen Post melden? (optional)',
      whyReportObject: 'Warum möchtest du dieses Objekt melden? (optional)',
      whyReportComment: 'Warum möchtest du diesen Kommentar melden? (optional)',
      reasonPlaceholder: 'Begründung (optional)...',
      postReportedSuccess: 'Post erfolgreich gemeldet',
      objectReportedSuccess: 'Objekt erfolgreich gemeldet',
      commentReportedSuccess: 'Kommentar erfolgreich gemeldet',
      categories: {
        hateSpeech: 'Hate speech / Diskriminierung',
        spam: 'Spam / Werbung',
        personalData: 'Veröffentlichung von persönlichen Daten',
        misinformation: 'Verbreitung von Misinformationen',
        violence: 'Bedrohung von Gewalt',
        sexual: 'Sexualisierte Inhalte',
      },
      // Marketplace-specific report categories
      marketplaceCategories: {
        inappropriateContent: 'Unpassender Inhalt',
        threateningContent: 'Bedrohender Inhalt',
        commercialSeller: 'Mutmaßlich gewerblicher Anbieter',
        fraudulentContent: 'Betrügerischer Inhalt',
        counterfeit: 'Fälschung',
        academicIntegrity: 'Verstoß gegen unseren Community Guideline für akademische Integrität',
      },
    },

    // Accessibility
    a11y: {
      skipToContent: 'Zum Hauptinhalt springen',
      menuOpen: 'Menü öffnen',
      menuClose: 'Menü schließen',
      showPassword: 'Passwort anzeigen',
      hidePassword: 'Passwort verbergen',
    },

    // Issue #119: ImageModal accessibility translations
    imageModal: {
      dialogLabel: 'Bild {current} von {total}',
      imageAlt: 'Bild {current} von {total}',
      imageAnnouncement: 'Bild {current} von {total}',
      previousImage: 'Vorheriges Bild',
      nextImage: 'Nächstes Bild',
      imageNavigation: 'Bildnavigation',
      goToImage: 'Gehe zu Bild {number}',
    },

    // Shared ImagePreviewsGrid component translations
    imagePreviewsGrid: {
      selectedImages: 'Ausgewählte Bilder',
      preview: 'Vorschau',
      removeImage: 'Bild entfernen',
      previewImageBadge: 'Dieses Bild wird als Vorschau verwendet',
    },

    // Issue #161: Bad words modal
    badWords: {
      title: 'Inhalt nicht erlaubt',
      postMessage: 'Der Beitrag konnte nicht hochgeladen werden, da er unangemessene Wörter enthält:',
      objectMessage: 'Das Objekt konnte nicht hochgeladen werden, da es unangemessene Wörter enthält:',
      commentMessage: 'Das Kommentar konnte nicht hochgeladen werden, da es unangemessene Wörter enthält:',
      reviewMessage: 'Die Bewertung konnte nicht hochgeladen werden, da sie unangemessene Wörter enthält:',
      understood: 'Alles klar',
    },

    // Issue #230: Floating plus button
    floatingPlusButton: {
      ariaLabel: 'Neuen Inhalt erstellen',
      createPost: 'Neuen Beitrag erstellen',
      createMarketplace: 'Neues Marktplatz-Objekt erstellen',
    },

    // Issue #312: Social media sharing
    share: {
      sharePost: 'Post teilen',
      shareObject: 'Objekt teilen',
      shareCourse: 'Kursbewertung teilen',
      channels: 'Teilen via',
      nativeShare: 'Teilen',
      moreOptions: 'Mehr',
      shareViaWhatsApp: 'Per WhatsApp teilen',
      shareViaTelegram: 'Per Telegram teilen',
      shareViaSignal: 'Per Signal teilen',
      shareViaInstagram: 'Per Instagram teilen',
      copyLink: 'Link kopieren',
      copied: 'Kopiert!',
      errorSharing: 'Fehler beim Teilen',
      errorCopying: 'Fehler beim Kopieren',
      // Share message formats
      postMessage: 'Neuer Beitrag in UNIVERSE: {content}',
      objectMessage: 'UNIVERSE Marktplatz: {title}',
      courseMessage: 'Kursbewertung von {name}',
      // Access restriction messages
      accessDenied: 'Leider kannst du nicht auf die Inhalte anderer Universitäten zugreifen.',
      contentNotFound: 'Der geteilte Inhalt wurde nicht gefunden.',
      loginRequired: 'Bitte melde dich an, um diesen Inhalt zu sehen.',
    },

    // Issue #204 & #268: Google Ads - Optimized consent flow
    ads: {
      consent: {
        welcome: '🚀 Willkommen zu UNIVERSE!',
        title: 'Interesse an exklusiven Studenten-Deals? ✨',
        description: 'Aktiviere personalisierte Empfehlungen und entdecke exklusive Studentenrabatte und Angebote rund um deine Uni! Ohne Zustimmung zeigen wir dir allgemeine Anzeigen.',
        benefitsLabel: 'Vorteile personalisierter Angebote',
        benefitsIntro: 'So verpasst du keine:',
        benefit1: '🥡 Food-Deals in deiner Nähe',
        benefit2: '🛍️ Studentenrabatte bei lokalen Shops',
        benefit3: '📍 Jobs rund um deine Uni',
        changeableNotice: 'Anzeigen werden immer gezeigt, nur die Personalisierung ändert sich. Du kannst die Einstellung jederzeit in ›Kontoeinstellungen‹ ändern.',
        accept: 'Personalisiert',
        decline: 'Allgemein',
        acceptAriaLabel: 'Personalisierte Angebote aktivieren',
        declineAriaLabel: 'Allgemeine Anzeigen beibehalten',
      },
      settings: {
        sectionTitle: 'Personalisierte Angebote',
        toggleLabel: 'Anzeigen personalisieren, um exklusive Studenten-Deals rund um deine Uni zu erhalten.',
        title: 'Werbung',
        adsEnabled: 'Werbung aktiviert',
        revokeConsent: 'Einwilligung widerrufen',
        grantConsent: 'Werbung aktivieren',
      },
      // Issue #275: Confirmation messages after accepting/declining
      confirmation: {
        positive: 'Okay, wir zeigen dir exklusive Studenten-Deals!',
        negative: 'Okay, du kannst personalisierte Angebote jederzeit in den Kontoeinstellungen aktivieren!',
      },
    },

    // Issue #185: Bug report for beta testers
    bugReport: {
      title: 'Bug melden',
      beta: 'BETA',
      stepsTitle: 'Schritte zum Reproduzieren',
      step: 'Schritt',
      stepPlaceholder: 'z.B. Anmelden und auf "Mein Marktplatz" klicken',
      addStep: 'Weitere Schritte hinzufügen',
      removeStep: 'Schritt entfernen',
      technicalTitle: 'Angaben zu technischen Details',
      connectionQuality: 'Internetverbindung',
      connectionGood: 'Gut',
      connectionMedium: 'Mittel',
      connectionBad: 'Schlecht',
      os: 'Betriebssystem',
      save: 'Speichern',
      submit: 'Absenden',
      submitting: 'Wird gesendet...',
      cancelTitle: 'Bug-Bericht abbrechen?',
      cancelMessage: 'Dein Entwurf wird nicht gespeichert.',
      cancelConfirm: 'Abbrechen',
      cancelStay: 'Fortsetzen',
      draftSaved: 'Entwurf gespeichert',
      submitSuccess: 'Bug-Bericht erfolgreich gesendet!',
      submitError: 'Fehler beim Senden des Bug-Berichts',
      step1Required: 'Bitte gib den ersten Schritt ein.',
      connectionRequired: 'Bitte wähle deine Internetverbindung aus.',
      osRequired: 'Bitte wähle dein Betriebssystem aus.',
      required: 'Pflichtfeld',
      // Issue #193: Expected and actual result fields
      expectedResult: 'Erwartetes Ergebnis',
      expectedResultPlaceholder: 'Was sollte passieren?',
      actualResult: 'Aktuelles Ergebnis',
      actualResultPlaceholder: 'Was ist stattdessen passiert?',
      // Issue #337: Screenshot upload
      screenshot: 'Screenshot',
      screenshotHint: 'Max. 2 MB, JPG/PNG/WebP',
      screenshotTooLarge: 'Screenshot ist zu groß (max. 2 MB).',
      screenshotInvalidType: 'Ungültiger Dateityp. Erlaubt: JPG, PNG, WebP.',
      removeScreenshot: 'Screenshot entfernen',
      addScreenshot: 'Screenshot hinzufügen',
    },

    // Issue #232: User feedback
    feedback: {
      title: 'Feedback senden',
      npsQuestion: 'Wie wahrscheinlich ist es, dass du UNIVERSE einem Freund empfiehlst?',
      npsScaleLabel: 'Bewertungsskala 1 bis 10',
      of10: 'von 10',
      unlikely: '1=unwahrscheinlich',
      veryLikely: '10=sehr wahrscheinlich',
      npsRequired: 'Bitte wähle eine Bewertung aus.',
      feedbackLabel: 'Dein Feedback (optional)',
      feedbackPlaceholder: 'Teile uns deine Gedanken mit...',
      feedbackOptionalHint: 'Dieses Feld ist optional',
      submit: 'Absenden',
      submitting: 'Wird gesendet...',
      submitError: 'Fehler beim Senden des Feedbacks',
      thankYou: 'Vielen Dank für dein Feedback! Das hilft uns, die App zu verbessern.',
    },
  },

  en: {
    // Common
    back: 'Back',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    send: 'Send',
    loading: 'Loading...',
    loadingPosts: 'Loading posts...',
    loadingMorePosts: 'Loading more contents...',
    allPostsLoaded: 'All contents loaded',
    error: 'Error',
    success: 'Success',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    none: 'None',
    more: 'More',
    less: 'Less',
    readMore: 'read more',
    readLess: 'read less',
    backToLogin: 'Back to Login',
    reported: 'REPORTED',
    noResults: 'No results found',

    // Navigation
    nav: {
      home: 'Home',
      profile: 'Profile',
      marketplace: 'Marketplace',
      courses: 'Courses',
      chat: 'Chat',
      settings: 'Settings',
      logout: 'Log out',
      loggingOut: 'Logging out...',
    },

    // Bottom Navigation
    bottomNav: {
      home: 'Home',
      messages: 'Messages',
      post: 'Post',
      notifications: 'Notifications',
      profile: 'Profile',
    },

    // Hamburger Menu
    menu: {
      meinePosts: 'My Posts',
      meinMarktplatz: 'My Marketplace',
      meineKursbewertungen: 'My Course Reviews',
      changePassword: 'Change Password',
      language: 'Language',
      logout: 'Log out',
    },

    // Tabs
    tabs: {
      hotPosts: 'Hot Posts',
      newPosts: 'New Posts',
      marketplace: 'Marketplace',
      iOffer: 'I offer',
      iSearch: 'I search',
      favorites: 'Favorites',
      myObjects: 'My Objects',
    },

    // Auth
    auth: {
      login: 'Log in',
      loggingIn: 'Logging in...',
      register: 'Register',
      registering: 'Creating...',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      repeatPassword: 'Repeat password',
      forgotPassword: 'Forgot Password',
      createAccount: 'Create Account',
      alreadyHaveAccount: 'Already have an account?',
      loginHere: 'Log in here',
      noAccount: 'No account yet?',
      studentEmail: 'Student Email',
      studentEmailLabel: 'Student email address',
      firstName: 'First Name',
      lastName: 'Last Name',
      welcomeBack: 'Welcome back!',
      loginForm: 'Login form',
      registerForm: 'Registration form',
      emailRequired: 'Email is required',
      passwordRequired: 'Password is required',
      firstNameRequired: 'First name is required',
      lastNameRequired: 'Last name is required',
      invalidEmail: 'Invalid email address. Please use your student email address from your university. Your university may not yet be available in Universe.',
      weakPassword: 'Password must be at least 8 characters and contain a combination of letters, numbers and special characters.',
      repeatPasswordRequired: 'Please repeat your password',
      passwordMismatch: 'Passwords do not match',
      verificationHelp: 'Your account will be activated after you verify your email.',
      // Issue #68: Privacy policy notice on registration
      privacyPolicyNotice: 'By creating an account, you agree to our',
      verificationEmailSent: 'A verification link has been sent to your email. Please verify your email within 24 hours.',
      // Issue #380: Immediate verification-email failure screen
      verificationEmailImmediateErrorPrefix: 'An error has occurred. Please try again. If this error persists, please contact ',
      verificationEmailImmediateErrorSuffix: '.',
      resendLinkButton: 'Resend link',
      allesKlar: 'Okay',
      university: 'University',
      emailNotReceived: 'Email not received?',
      resendVerification: 'Resend verification email',
      noLinkReceived: 'Haven\'t received a link?',
      verificationResent: 'Verification link has been resent',
      emailLabel: 'Your email address',
      resendHelpText: 'Enter the email address for which you would like to receive a new verification email.',
      sending: 'Sending...',
      resendVerificationButton: 'Resend verification email',
      verificationLinkSentSuccess: 'The verification link has been sent successfully.',
      customerServiceNotice: 'If you still haven\'t received an email after trying again, please contact our customer service at ',
      customerServiceEmail: 'kundenservice@universe-app.online',
      registerHere: 'Register here',
      hidePasswordRepeat: 'Hide password confirmation',
      showPasswordRepeat: 'Show password confirmation',
      systemUnavailable: 'The system is temporarily unavailable. Please try again later.',
      // Issue #235: AGB checkbox translations
      agbCheckboxPrefix: 'I have read the',
      agbLinkText: 'Terms and Conditions',
      agbCheckboxSuffix: 'and accept them.',
      agbRequired: 'To create an account with us, you must accept our Terms and Conditions.',
    },

    // Forgot Password
    forgotPassword: {
      title: 'Forgot Password',
      sentTitle: 'Password Sent',
      instructions: 'Enter your student email address to receive a one-time password.',
      sendOtp: 'Send One-Time Password',
      sending: 'Sending...',
      backToLogin: 'Back to Login',
      checkEmail: 'Please check your email inbox.',
      otpValid: 'The one-time password is valid for 24 hours.',
      understood: 'Got it',
      emailNotFound: 'This email address could not be found.',
      defaultSuccess: 'A one-time password has been sent to your email address.',
    },

    // Profile
    profile: {
      title: 'Profile',
      accountInfo: 'Account Information',
      account: 'Account',
      changePassword: 'Change Password',
      appSettings: 'App Settings',
      notifications: 'Notification Settings',
      language: 'Language',
      display: 'Display Settings',
      privacy: 'Privacy & Policies',
      terms: 'Terms and Conditions',
      privacyPolicy: 'Privacy Policy',
      communityGuidelines: 'Community Guidelines',
      uploadPhoto: 'Upload Photo',
      changePhoto: 'Change Photo',
      // Issue #84: Profile photo translations
      photoAlt: 'Profile photo',
      invalidFileType: 'Invalid file format. Allowed: JPEG, PNG, WebP',
      fileTooLarge: 'File is too large (max 5MB)',
      uploadError: 'Error uploading profile photo',
      // Issue #137: Account settings
      accountSettings: 'Account Settings',
    },

    // Language Settings
    languageSettings: {
      title: 'Language',
      setPreferred: 'Set preferred language',
      german: 'German',
      english: 'English',
      saving: 'Saving...',
      saveError: 'Error saving language preference',
    },

    // Issue #137: Account Settings
    accountSettings: {
      title: 'Account Settings',
      profileInfo: 'Profile Information',
      name: 'Name',
      email: 'E-Mail',
      university: 'University',
      accountStatus: 'Account Status',
      accountStatusActive: 'Active since',
      accountManagement: 'Account Management',
      deleteAccount: 'Delete Account',
    },

    // Issue #137: Delete Account
    deleteAccount: {
      title: 'Delete Account',
      step: 'Step {current} of {total}',
      step1Title: 'it\'s a bummer, that you leave us.',
      step1Text: 'Do you really want to delete your account? You will no longer be able to contact your friends, get messages or access any content of UNIVERSE.',
      step2Title: 'Why do you want to delete your account?',
      step2Text: 'Please tell us why you want to leave UNIVERSE. (select at least 1 option)',
      reason1: 'I\'m not interested in the content of UNIVERSE',
      reason2: 'I have finished my studies and no longer need the app',
      reason3: 'I\'m dissatisfied with the community',
      reason4: 'I receive unwanted contact requests',
      reason5: 'Other',
      step3Title: 'Please enter your password to permanently delete your account.',
      personalDataQuestion: 'What happens to your personal data?',
      personalDataAnswer: 'Your personal data will be completely deleted.',
      contentQuestion: 'What happens to your content?',
      contentAnswer: 'All marketplace objects created by you will be deleted. Posts, comments, course reviews and messages created by you will not be deleted, but anonymized to remove personal reference. If you do not want your created content to remain, you have the option to delete the content before deleting your account.',
      passwordPlaceholder: 'Password',
      passwordRequired: 'Please enter your password.',
      wrongPassword: 'Wrong password.', // Issue #150
      validating: 'Validating...', // Issue #150
      continue: 'Continue',
      deleteButton: 'Delete Account',
      confirmTitle: 'Delete Account',
      confirmText: 'Are you sure you want to delete your account? You have 30 days to log in again and cancel the deletion.',
      confirmDelete: 'Yes, delete',
      deleting: 'Deleting...',
      errorGeneric: 'An error occurred. Please try again.',
    },

    // Display Settings (Issue #98: Dark Mode)
    displaySettings: {
      title: 'Display Settings',
      setPreferred: 'Set display mode',
      lightMode: 'Light Mode',
      darkMode: 'Dark Mode',
    },

    // Notification Settings (Issue #88)
    notificationSettings: {
      title: 'Notification Settings',
      allNotifications: 'Notifications',
      newComment: 'New Comment',
      newLike: 'New Like',
      newHeart: 'New Heart',
      newChat: 'New Chat',
      newStatus: 'New update of saved marketplace objects',
      statusDescription: '',
      saving: 'Saving...',
      saveError: 'Error saving preference',
    },

    // Change Password
    changePassword: {
      title: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      submit: 'Continue',
      submitting: 'Changing...',
      newPasswordTitle: 'Enter new password',
      otpFlowTitle: 'Set new password',
      otpFlowSubtitle: 'Please set a new password for your account.',
      successMessage: 'Password changed successfully!',
      errors: {
        currentRequired: 'Current password is required',
        newRequired: 'New password is required',
        confirmRequired: 'Please confirm your new password',
        mismatch: 'Passwords do not match',
        weak: 'Password must be at least 8 characters and contain a combination of letters, numbers and symbols.',
        sessionExpired: 'Session expired. Please log in again.',
        serverError: 'The system is temporarily unavailable. Please try again later.',
      },
    },

    // Marketplace
    marketplace: {
      title: 'Marketplace',
      createObject: 'Create new object',
      createObjectTitle: 'Create new marketplace object',
      price: 'Price',
      priceLabel: 'Price *',
      titleLabel: 'Title *',
      descriptionLabel: 'Description *',
      description: 'Description',
      uploadImagesRequired: 'Upload images (required) *',
      uploadImagesOptional: 'Upload images (optional)',
      addMoreImages: 'Add more images',
      maxImagesInfo: 'Maximum {count} images, max. {size}MB each',
      maxImagesError: 'Maximum {count} images per post allowed',
      invalidFileType: 'Invalid file type: {name}. Only JPEG, PNG and WebP are allowed.',
      imageTooLarge: 'Image is too large',
      errorCompressing: 'Error compressing image',
      errorLoading: 'Error loading image',
      errorReading: 'Error reading file',
      pleaseEnterTitle: 'Please enter a title',
      pleaseEnterDescription: 'Please enter a description',
      pleaseEnterValidPrice: 'Please enter a valid price',
      pleaseUploadImage: 'Please upload at least one image',
      errorCreating: 'Error creating object',
      objectCreatedSuccess: 'Object created successfully!',
      placeholderTitleOffer: 'e.g. Selling bicycle',
      placeholderTitleSearch: 'e.g. Looking for math textbook',
      placeholderDescriptionOffer: 'Describe your object...',
      placeholderDescriptionSearch: 'Describe what you are looking for...',
      creating: 'Creating...',
      create: 'Create',
      freeGiveaway: 'Free of charge',
      sold: 'SOLD',
      markAsSold: 'Mark as sold',
      markAsSoldConfirm: 'Do you really want to mark this object as sold? This action cannot be undone.',
      markAsSoldConfirmShort: 'Do you really want to mark this object as sold?',
      markAsSoldSuccess: 'Object was successfully marked as sold',
      // Issue #329: "I found it" for search objects
      found: 'FOUND',
      markAsFound: 'I found it',
      markAsFoundConfirm: 'Do you really want to mark this object as found? This action cannot be undone.',
      markAsFoundConfirmShort: 'Do you really want to mark this object as found?',
      markAsFoundSuccess: 'Object was successfully marked as found',
      objectNoLongerAvailable: 'This object is no longer available',
      marking: 'Marking...',
      markAsAvailable: 'Mark as available',
      contactSeller: 'Send message',
      editObject: 'Edit object',
      deleteObject: 'Delete object',
      deleteObjectConfirm: 'Do you really want to delete this object?',
      report: 'Report',
      reportObject: 'Report object',
      noObjects: 'No objects found',
      objectNotFound: 'Object not found',
      noFavorites: 'You have not marked any objects as favorites yet.',
      noOwnObjects: 'You have not created any objects yet.',
      loadingObjects: 'Loading objects...',
      errorLoadingObjects: 'Error loading objects',
      objectTitle: 'Title',
      objectDescription: 'Description',
      objectImages: 'Images',
      existingImages: 'Current images:',
      newImages: 'New images:',
      addImages: 'Add images',
      compressing: 'Compressing...',
      searchPlaceholder: 'Search...',
      searchAriaLabel: 'Search marketplace',
      searchButtonAriaLabel: 'Start search',
      confirmDelete: 'Are you sure you want to delete this object?',
      hearts: 'Hearts',
      clicks: 'Clicks',
      options: 'Options',
      enterTitle: 'Please enter a title',
      enterPrice: 'Please enter a price',
      enterDescription: 'Please enter a description',
      saveError: 'Error saving',
      markSoldError: 'Error marking as sold',
      previousImage: 'Previous image',
      nextImage: 'Next image',
      removeHeart: 'Remove heart',
      addHeart: 'Add heart',
      // Issue #385: Disabled heart for sold marketplace objects
      heartDisabledSold: 'Liking not possible – object has been sold',
      edited: 'edited',
      photo: 'Photo',
      // Issue #225: Clickable preview images
      openImageGallery: 'Open image in gallery',
      previewImage: 'Preview image',
    },

    // Posts
    posts: {
      createPost: 'Create new post',
      editPost: 'Edit post',
      deletePost: 'Delete post',
      writePost: 'What would you like to share?',
      noPosts: 'No posts found',
      noOwnPosts: 'You have not created any posts yet.',
      myPosts: 'My Posts',
      likes: 'Likes',
      comments: 'Comments',
      share: 'Share',
      report: 'Report',
      reportPost: 'Report post',
      confirmDelete: 'Are you sure you want to delete this post?',
      deleting: 'Deleting...',
      saving: 'Saving...',
      reporting: 'Reporting...',
      // Issue #288: Search translations
      searchPlaceholder: 'Search posts...',
      searchAriaLabel: 'Search posts',
      searchButtonAriaLabel: 'Start search',
      // Issue #317: Shared post indicator
      sharedPost: 'Shared post',
      // Issue #335: Link accessibility
      externalLink: 'External link (opens in new tab)',
      opensInNewTab: 'opens in new tab',
    },

    // Comments
    comments: {
      title: 'Comments',
      showComments: 'Show comments',
      loadingComments: 'Loading comments...',
      noComments: 'No comments yet',
      writeComment: 'Write a comment...',
      anonymous: 'Anonymous',
      author: 'Author', // Issue #141: Label for anonymous comments from post author
      editComment: 'Edit comment',
      deleteComment: 'Delete comment',
      reportComment: 'Report comment',
      confirmDeleteComment: 'Are you sure you want to delete this comment?',
      deleteSuccess: 'Comment successfully deleted',
      reportSuccess: 'Comment successfully reported',
      reportedComment: 'Reported comment', // Issue #413
      emptyError: 'Comment cannot be empty',
      enterComment: 'Please enter a comment',
      sending: 'Sending...', // Issue #177: Shared CommentInput component
    },

    // Favorites
    favorites: {
      onlyFavorites: 'Favorites only',
      filterActive: 'Filter active',
    },

    // Course Reviews
    courseReview: {
      title: 'Course Reviews',
      detailTitle: 'Course Details',
      createReview: 'Create review',
      editReview: 'Edit review',
      deleteReview: 'Delete review',
      noReviews: 'No reviews found',
      noCourses: 'No courses found',
      courseCountSingular: 'course',
      courseCountPlural: 'courses',
      rating: 'Rating',
      review: 'Review',
      reviews: 'Reviews',
      anonymous: 'Anonymous',
      rateWithStars: 'Rate this course with 1-5 stars',
      sharePlaceholder: 'Share your experience or tips (optional)',
      creating: 'Creating...',
      create: 'Create',
      saving: 'Saving...',
      confirmDelete: 'Are you sure you want to delete this review?',
      deleting: 'Deleting...',
      loadingCourses: 'Loading courses...',
      loadingMore: 'Loading more courses...',
      allLoaded: 'All courses loaded',
      errorLoading: 'Error loading courses',
      seeAllReviews: 'See all reviews',
      disclaimer: 'Please note that the course information is provided without warranty. For official details, please refer to your university\'s study plan.',
      searchPlaceholder: 'Search courses...',
      searchAriaLabel: 'Search for courses',
      searchButtonAriaLabel: 'Start search',
      sort: {
        title: 'Sort by',
        sortBy: 'Sort by',
        reviewsDescending: 'The number of reviews',
        ratingAscending: 'Rating ascending',
        ratingDescending: 'Rating descending',
        nameAsc: 'A-Z',
        nameDesc: 'Z-A',
        appliedSorts: 'Applied sort criteria',
        clear: 'Clear',
        clearAriaLabel: 'Clear sort criteria',
      },
      filter: {
        title: 'Filter Options',
        degree: 'Degree',
        studyProgram: 'Study Program',
        searchProgram: 'Search for study program',
        language: 'Language',
        semester: 'Semester',
        bachelor: 'Bachelor',
        master: 'Master',
        german: 'German',
        english: 'English',
        both: 'Both',
        winterSemester: 'Winter Semester',
        summerSemester: 'Summer Semester',
        apply: 'Apply',
        reset: 'Reset filters',
        // Issue #78: Rating-related filters
        ratingSection: 'Rating',
        hasReviews: 'Courses with reviews',
        myReviews: 'Courses with my review',
        minStars: 'Courses with at least [x] stars',
        minStarsAria: 'At least {count} stars',
        minStarsRequired: 'Please select a star rating.',
      },
    },

    // Chat
    chat: {
      title: 'Chat',
      noMessages: 'No messages',
      typeMessage: 'Type a message...',
      send: 'Send',
      loadingConversation: 'Loading conversation...',
      errorLoadingConversation: 'Error loading conversation',
      errorSendingMessage: 'Error sending message',
      privacyNotice: 'We protect your privacy. Your messages are encrypted and only visible to the recipient.',
      // Issue #123: Unread messages marker
      unreadMessage: 'unread message',
      unreadMessages: 'unread messages',
      // Issue #127: Date divider accessibility
      messagesFrom: 'Messages from',
    },

    // Chat List (Issue #91, #92, #93, #121, #122, #173)
    chatList: {
      title: 'Messages',
      loading: 'Loading messages...',
      errorLoading: 'Error loading messages',
      noConversations: 'No messages',
      noConversationsHint: 'Contact a seller in the marketplace to start a conversation.',
      // Issue #121: Hide chat feature
      deleteChat: 'Delete chat',
      blockUser: 'Block {name}',
      deleteChatTitle: 'Delete chat?',
      deleteChatMessage: 'The chat will be removed from your list. If {name} messages you again, the chat will reappear.',
      deleteChatConfirm: 'Delete',
      deleteChatConfirming: 'Deleting...',
      // Issue #122: Block user feature
      blockUserTitle: 'Do you really want to block {name}?',
      blockUserMessage: '{name} will no longer be able to contact you. You will not receive any messages from {name}.',
      blockUserConfirm: 'Block {name}',
      blockUserConfirming: 'Blocking...',
      blockUserCancel: 'Cancel',
      blockUserSuccess: 'You have blocked {name}',
      // Issue #122: Accessibility translations (WCAG 2.1)
      optionsHint: 'Shift+Enter for options',
      optionsMenu: 'Chat options',
      conversationWith: 'Conversation with',
      unread: 'Unread',
      // Issue #173: Mute notification feature
      muteNotification: 'Mute notifications',
      unmuteNotification: 'Unmute notifications',
      mutingNotification: 'Updating...',
      muteError: 'Error changing notification setting',
      muted: 'Muted',
      mutedNotification: 'Notifications muted',
    },

    // Notifications (Issue #87)
    notifications: {
      title: 'Notifications',
      loading: 'Loading notifications...',
      errorLoading: 'Error loading notifications',
      noNotifications: 'No notifications',
      noNotificationsHint: 'Notifications about comments, likes and more will appear here.',
      markAllRead: 'Mark all as read',
      justNow: 'Just now',
      minutesAgo: 'min ago',
      hoursAgo: 'h ago',
      daysAgo: 'days ago',
      // Notification message templates
      commentMessage: '{actor} left a comment on your post "{title}".',
      commentMessageAnonymous: 'Someone left an anonymous comment on your post "{title}".',
      likeMessage: 'Someone liked your post "{title}".',
      heartMessage: 'Someone is interested in your marketplace item "{title}".',
      chatMessage: '{actor} sent you a message.',
      favoriteSoldMessage: 'The marketplace item "{title}" has been sold.',
      // Issue #131: Delete notifications
      selectAll: 'Select all',
      deleteSelected: 'Delete selected',
      selected: 'selected',
      selectionMode: 'Selection mode',
      exitSelectionMode: 'Exit selection mode',
      longPressToSelect: 'Long press to select',
      notificationSelected: 'Notification selected',
      notificationDeselected: 'Notification deselected',
      deleteSuccess: 'Notification(s) deleted',
      deleteError: 'Error deleting notifications',
      unread: 'Unread',
    },

    // Seller Contact
    sellerContact: {
      title: 'Send Message',
      message: 'Message',
      messagePlaceholder: 'Write your message to the seller...',
      send: 'Send Message',
      sending: 'Sending...',
      enterMessage: 'Please enter a message',
      sendError: 'Error sending message',
      objectNotFound: 'Object not found',
      seller: 'Seller',
      gdprNotice: 'The recipient of your message will see your first name and profile.',
    },

    // Create Options Menu
    createOptions: {
      newPost: 'Create new post',
      newMarketplace: 'Create new marketplace object',
    },

// Create Post Page (Issue #101)
    createPost: {
      pageTitle: 'Create new post',
      yourThoughts: 'Your thoughts...',
      placeholder: 'What would you like to share?',
      anonymous: 'Anonymous',
      emoji: 'Emoji',
      addPhotos: 'Add photos (optional)',
      create: 'Create',
      creating: 'Creating...',
    },

    // Issue #105: Unsaved changes warning
    unsavedChanges: {
      title: 'Leave page?',
      message: 'Your drafts will not be saved.',
      leave: 'Leave',
      stay: 'Stay',
    },
    // Report
    report: {
      title: 'Report',
      reason: 'Reason',
      additionalInfo: 'Additional Information',
      submit: 'Report',
      submitting: 'Reporting...',
      selectCategory: 'Please select a category for the report:',
      chooseCategory: '-- Choose category --',
      whyReport: 'Why do you want to report this post? (optional)',
      whyReportObject: 'Why do you want to report this object? (optional)',
      whyReportComment: 'Why do you want to report this comment? (optional)',
      reasonPlaceholder: 'Reason (optional)...',
      postReportedSuccess: 'Post reported successfully',
      objectReportedSuccess: 'Object reported successfully',
      commentReportedSuccess: 'Comment reported successfully',
      categories: {
        hateSpeech: 'Hate speech / Discrimination',
        spam: 'Spam / Advertising',
        personalData: 'Disclosure of personal data',
        misinformation: 'Spreading misinformation',
        violence: 'Threat of violence',
        sexual: 'Sexual content',
      },
      // Marketplace-specific report categories
      marketplaceCategories: {
        inappropriateContent: 'Inappropriate content',
        threateningContent: 'Threatening content',
        commercialSeller: 'Suspected commercial seller',
        fraudulentContent: 'Fraudulent content',
        counterfeit: 'Counterfeit',
        academicIntegrity: 'Violation of our Community Guideline for academic integrity',
      },
    },

    // Accessibility
    a11y: {
      skipToContent: 'Skip to main content',
      menuOpen: 'Open menu',
      menuClose: 'Close menu',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
    },

    // Issue #119: ImageModal accessibility translations
    imageModal: {
      dialogLabel: 'Image {current} of {total}',
      imageAlt: 'Image {current} of {total}',
      imageAnnouncement: 'Image {current} of {total}',
      previousImage: 'Previous image',
      nextImage: 'Next image',
      imageNavigation: 'Image navigation',
      goToImage: 'Go to image {number}',
    },

    // Shared ImagePreviewsGrid component translations
    imagePreviewsGrid: {
      selectedImages: 'Selected images',
      preview: 'Preview',
      removeImage: 'Remove image',
      previewImageBadge: 'This image will be used as preview',
    },

    // Issue #161: Bad words modal
    badWords: {
      title: 'Content not allowed',
      postMessage: 'The post could not be uploaded because it contains inappropriate words:',
      objectMessage: 'The object could not be uploaded because it contains inappropriate words:',
      commentMessage: 'The comment could not be uploaded because it contains inappropriate words:',
      reviewMessage: 'The review could not be uploaded because it contains inappropriate words:',
      understood: 'Understood',
    },

    // Issue #185: Bug report for beta testers
    bugReport: {
      title: 'Report Bug',
      beta: 'BETA',
      stepsTitle: 'Steps to Reproduce',
      step: 'Step',
      stepPlaceholder: 'e.g. Log in and click "My Marketplace"',
      addStep: 'Add more steps',
      removeStep: 'Remove step',
      technicalTitle: 'Technical Details',
      connectionQuality: 'Internet Connection',
      connectionGood: 'Good',
      connectionMedium: 'Medium',
      connectionBad: 'Bad',
      os: 'Operating System',
      save: 'Save',
      submit: 'Submit',
      submitting: 'Submitting...',
      cancelTitle: 'Cancel bug report?',
      cancelMessage: 'Your draft will not be saved.',
      cancelConfirm: 'Cancel',
      cancelStay: 'Continue',
      draftSaved: 'Draft saved',
      submitSuccess: 'Bug report submitted successfully!',
      submitError: 'Error submitting bug report',
      step1Required: 'Please enter the first step.',
      connectionRequired: 'Please select your internet connection.',
      osRequired: 'Please select your operating system.',
      required: 'required',
      // Issue #193: Expected and actual result fields
      expectedResult: 'Expected Result',
      expectedResultPlaceholder: 'What should happen?',
      actualResult: 'Actual Result',
      actualResultPlaceholder: 'What happened instead?',
      // Issue #337: Screenshot upload
      screenshot: 'Screenshot',
      screenshotHint: 'Max. 2 MB, JPG/PNG/WebP',
      screenshotTooLarge: 'Screenshot is too large (max. 2 MB).',
      screenshotInvalidType: 'Invalid file type. Allowed: JPG, PNG, WebP.',
      removeScreenshot: 'Remove screenshot',
      addScreenshot: 'Add screenshot',
    },

    // Issue #232: User feedback
    feedback: {
      title: 'Send Feedback',
      npsQuestion: 'How likely are you to recommend UNIVERSE to a friend?',
      npsScaleLabel: 'Rating scale 1 to 10',
      of10: 'of 10',
      unlikely: '1=unlikely',
      veryLikely: '10=very likely',
      npsRequired: 'Please select a rating.',
      feedbackLabel: 'Your feedback (optional)',
      feedbackPlaceholder: 'Share your thoughts with us...',
      feedbackOptionalHint: 'This field is optional',
      submit: 'Submit',
      submitting: 'Submitting...',
      submitError: 'Error submitting feedback',
      thankYou: 'Thank you for your feedback! It helps us improve the app.',
    },

    // Issue #312: Social media sharing
    share: {
      sharePost: 'Share post',
      shareObject: 'Share object',
      shareCourse: 'Share course review',
      channels: 'Share via',
      nativeShare: 'Share',
      moreOptions: 'More',
      shareViaWhatsApp: 'Share via WhatsApp',
      shareViaTelegram: 'Share via Telegram',
      shareViaSignal: 'Share via Signal',
      shareViaInstagram: 'Share via Instagram',
      copyLink: 'Copy link',
      copied: 'Copied!',
      errorSharing: 'Error sharing',
      errorCopying: 'Error copying',
      // Share message formats
      postMessage: 'New Post in UNIVERSE: {content}',
      objectMessage: 'UNIVERSE Marketplace: {title}',
      courseMessage: 'Course review of: {name}',
      // Access restriction messages
      accessDenied: 'Sorry, you cannot access content from other universities.',
      contentNotFound: 'The shared content was not found.',
      loginRequired: 'Please log in to view this content.',
    },

    // Issue #204 & #268: Google Ads - Optimized consent flow
    ads: {
      consent: {
        welcome: '🚀 Welcome to UNIVERSE!',
        title: 'Interested in exclusive student deals? ✨',
        description: 'Activate personalized recommendations and get exclusive student discounts and deals around your university campus! Without consent, we show you general ads.',
        benefitsLabel: 'Benefits of personalized offers',
        benefitsIntro: 'Don\'t miss:',
        benefit1: '🥡 Food deals around you',
        benefit2: '🛍️ Student discounts at local shops',
        benefit3: '📍 Jobs around your university',
        changeableNotice: 'Ads are always shown, only personalization changes. You can change this setting at any time in ›Account Settings‹.',
        accept: 'Personalized',
        decline: 'General',
        acceptAriaLabel: 'Enable personalized offers',
        declineAriaLabel: 'Keep general ads',
      },
      settings: {
        sectionTitle: 'Personalized Offers',
        toggleLabel: 'Personalize ads to get exclusive student deals around your university.',
        title: 'Advertising',
        adsEnabled: 'Advertising enabled',
        revokeConsent: 'Revoke consent',
        grantConsent: 'Enable advertising',
      },
      // Issue #275: Confirmation messages after accepting/declining
      confirmation: {
        positive: 'Okay, we will show you exclusive student deals!',
        negative: 'Okay, you can always activate personalized offers in account settings!',
      },
    },
  },
};

export default translations;
